import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PermissionsService } from '../../services/permissions/permissions.service';

@Component({
  selector: 'app-people-help-modal',
  templateUrl: './people-help-modal.component.pug',
  styleUrls: ['./people-help-modal.component.scss'],
  standalone: false
})
export class PeopleHelpModalComponent implements OnInit {
  constructor(private modalService: BsModalService,
    private permissions: PermissionsService) {
    }

  ngOnInit(): void {}

  closeModal(){
    this.modalService.hide();
  }

}
